import userApi from '../apis/user'
import loveboxApi from '../apis/lovebox'
import enterApi from '../apis/enter'
import { KEY_USER_TOKEN } from '@/tools/storage'
import memberData from '@/tools/memberData'
import Vue from 'vue'
import momentApi from '../apis/moments'
import dealApi from '../apis/deal'
import { COUPON_RECORD_STATUS } from '@/tools/constant'

// 品牌好物索取列表每頁筆數，須與後端 BrandGiftController::ORDER_PER_PAGE_MAX 一致
// （後端會 min() 收斂，傳超過也只會拿到 50 筆，但頁碼換算會對不上）
const ORDER_PER_PAGE = 50

const state = {
  // resetPwStep: 0,
  msgStatus: '',
  token: '',
  marks: {
    WHITE: {
      curPage: 0,
      data: [],
      total: 0,
      lastPage: 1,
      loading: false
    },
    NORMAL: {
      curPage: 0,
      data: [],
      total: 0,
      lastPage: 1,
      loading: false
    },
    BLACK: {
      curPage: 0,
      data: [],
      total: 0,
      lastPage: 1,
      loading: false
    },
    curIdx: 0
  },
  userInfo: {
    id: 0,
    pics: '',
    avatar: [],
    catHash: 'normal',
    catId: 36,
    nickname: '',
    name: '',
    email: '',
    cellphone: '',
    phone: '',
    income: '', // 年收入
    infos: '', // 自我介绍
    createTime: '',
    lastLoginTime: '',
    isGOV: false,
    isComMger: false,
    isCompany: false,
    frozen: false,
    verify: {
      cell: false,
      ppl: false, // 实名
      email: false,
      love: false // 爱箱送
    },
    others: {
      addresses: {
        meets: {
          address: '',
          city: '',
          district: ''
        },
        rcvs: {
          address: '',
          city: '',
          district: ''
        },
        things: {
          address: '',
          city: '',
          district: ''
        },
        users: {
          address: '',
          city: '',
          district: ''
        }
      },
      banks: [{
        accounts: '',
        banks: '',
        branchs: '',
        title: ''
      }, {
        accounts: '',
        banks: '',
        branchs: '',
        title: ''
      }],
      birthday: {
        value: '',
        isPub: false
      },
      jobs: {
        value: '', // 枚举值 有工作 无工作 学生
        isPub: false
      },
      childs: {
        value: false, // 是否育儿
        isPub: false
      },
      marry: {
        value: false,
        isPub: false
      },
      gender: null,
      isIPOCompany: false,
      issues: [], // 关心议题
      fami: '' // 预设全家收件
    },
    verifyInfo: {
      position: '',
      fullname: '',
      cat_hash: '',
      taxnum: '',
      no: '',
      type: '',
      purpose: '',
      advise_no: '',
      contact_tel: '',
      contact_phone: '',
      contact_name: ''
    },
    bonus: 0, // 好人点
    reviewsRate: 0, // 感谢率
    charitys: 0, // 公益捐赠
    fans: 0, // 粉丝人数
    traces: 0, // 追踪人数
    inviteCode: '', // 爱箱送邀请码
    token: '',
    myGiftsTabIndex: 0,
    myGiftsStatusIndex: 0,
    myGifts: {
      status: '',
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myFlashGifts: {
      status: '',
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myNeedDonates: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myNeeds: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myRequestsTabIndex: 0,
    myRequestKeyword: '',
    myRequests: [{
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }],
    traceUsers: {
      currentPage: 0,
      lastPage: 1,
      total: 0,
      data: [],
      loading: false
    },
    traceGifts: {
      currentPage: 0,
      lastPage: 1,
      total: 0,
      data: [],
      loading: false
    },
    traceNeeds: {
      currentPage: 0,
      lastPage: 1,
      total: 0,
      data: [],
      loading: false
    },
    traceProvisions: {
      currentPage: 0,
      lastPage: 1,
      total: 0,
      data: [],
      loading: false
    },
    traceIdx: 0,
    companyProfile: {
      loading: false
    },
    medalList: {
      loading: false,
      data: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
  },
  otherUserInfo: {
    id: 0,
    pics: '',
    catHash: 'normal',
    catId: 36,
    nickname: 'GC贈物網 會員',
    name: '',
    email: '',
    cellphone: '',
    phone: '',
    income: '', // 年收入
    infos: '', // 自我介绍
    createTime: '',
    lastLoginTime: '',
    isGOV: false,
    isComMger: false,
    isCompany: false,
    frozen: false,
    verify: {
      cell: false,
      ppl: false, // 实名
      email: false,
      love: false // 爱箱送
    },
    myOthGifts: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    others: {
      addresses: {
        meets: {
          address: '',
          city: '',
          district: ''
        },
        rcvs: {
          address: '',
          city: '',
          district: ''
        },
        things: {
          address: '',
          city: '',
          district: ''
        },
        users: {
          address: '',
          city: '',
          district: ''
        }
      },
      banks: [{
        accounts: '',
        banks: '',
        branchs: '',
        title: ''
      }, {
        accounts: '',
        banks: '',
        branchs: '',
        title: ''
      }],
      birthday: {
        value: '',
        isPub: false
      },
      jobs: {
        value: '', // 枚举值 有工作 无工作 学生
        isPub: false
      },
      childs: {
        value: false, // 是否育儿
        isPub: false
      },
      marry: {
        value: false,
        isPub: false
      },
      gender: null,
      isIPOCompany: false,
      issues: [], // 关心议题
      fami: '' // 预设全家收件
    },
    verifyInfo: {
      position: '',
      fullname: '',
      cat_hash: '',
      taxnum: '',
      no: '',
      type: '',
      purpose: '',
      advise_no: '',
      contact_tel: '',
      contact_phone: '',
      contact_name: ''
    },
    bonus: 0, // 好人点
    reviewsRate: 0, // 感谢率
    charitys: 0, // 公益捐赠
    fans: 0, // 粉丝人数
    traces: 0, // 追踪人数
    inviteCode: '', // 爱箱送邀请码
    token: '',
    myGiftsTabIndex: 0,
    myGiftsStatusIndex: 0,
    profileGifts: {
      currentPage: 0,
      nextPageUrl: 'http://',
      status: '',
      data: []
    },
    profileNeeds: {
      currentPage: 0,
      nextPageUrl: 'http://',
      status: '',
      data: []
    },
    myGifts: {
      currentPage: 0,
      nextPageUrl: 'http://',
      status: '',
      data: []
    },
    myNeedDonates: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myNeeds: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myRequestsTabIndex: 0,
    myRequests: [{
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }], // 增加一個最後一項表示索取的GC代贈
    traceUsers: {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    },
    traceGifts: {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    },
    traceNeeds: {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    },
    sentLovebox: {
      currentPage: 0,
      total: 0,
      data: []
    },
    companyProfile: {
      loading: false
    },
    medalList: {
      loading: false,
      data: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
  },
  myRegisterCode: '', // 我的邀請碼，另GC代贈綁定碼為invite_code
  addresses: [],
  currentSelectedAddressId: 0,
  haveSucceedPalmbox: 0,
  isAccountRisk: false, // 分身需驗證手機號碼
  wallet: {
    points: 0,
    hasPasscode: 1,
    chargeCount: -1,
    chargeOrders: {
      items: [],
      loading: false,
      currentPage: 0,
      lastPage: 1,
      total: 0
    },
    records: {
      items: [],
      loading: false,
      currentPage: 0,
      lastPage: 1,
      total: 0
    },
    unpaidDeals: {
      giftRequests: [],
      needDonates: [],
      loveOrders: [],
      total: 0,
      loading: false
    },
    couponRecords: [
      {
        status: COUPON_RECORD_STATUS.VALID,
        data: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      {
        status: COUPON_RECORD_STATUS.USED,
        data: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      {
        status: COUPON_RECORD_STATUS.EXPIRED,
        data: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      }
    ]
  },
  sponsorRecrods: {
    loading: false,
    items: [],
    currentPage: 0,
    lastPage: 1,
    total: 0
  },
  thankTemplates: {
    loading: false,
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0
  },
  currentSelectedThankId: -1,
  // 品牌好物管理列表（企業端），參考 userInfo.myGifts 結構
  brandGifts: {
    status: '',
    currentPage: 0,
    nextPageUrl: 'http://',
    data: []
  },
  // 各品牌好物「索取列表」的分頁快取（每頁 50 筆，後端 ORDER_PER_PAGE_MAX）
  // 刻意與 brandGifts 分開：brandGifts.data 保持後端原始 payload，
  // 客戶端翻頁狀態獨立存放，避免把 view state 混進 API 物件
  // { [giftId]: { pages: { 1: [...], 2: [...] }, currentPage, total, lastPage, perPage, loading } }
  brandGiftOrders: {},
  // 品牌好物管理各 tab 的統計數字（後端隨列表回應平級帶回 status_counts）
  // 單位刻意不同：禮物態（all/pending/ongoing/pull_off/finish）為商品數，
  // 訂單態（received_money/confirm_ship/sent/returned）為訂單筆數
  // 只受 keyword 影響、不受 tab 與時間區間影響，故切 tab 時沿用不清空
  brandGiftStatusCounts: {}
}

const actions = {
  getLoginUserInfo ({commit, state}, {refresh = false, cb = null} = {}) {
    if (state.userInfo.id && !refresh) {
      cb && cb(state.userInfo)
    }
    userApi.getLoginUserInfo((data) => {
      commit('setLoginUserInfo', {data: data && data.user})
      if (cb) {
        return cb(data && data.user)
      }
    })
  },
  getOtherUserInfo ({commit, state}, {hash, cb = null}) {
    userApi.getUserInfo(hash, (data) => {
      if (data && !data.error) {
        return commit('setOtherUserInfo', {data})
      }

      cb && cb(data)
    })
  },
  getUserGifts ({commit, state}, {page, userId, status, type, noRequestList, cb}) {
    userApi.getUserGifts(page, userId, status, type, noRequestList, (data) => {
      if (data && !data.error) {
        commit('setMyGifts', {userId, status, data})
      }
      return cb(data)
    })
  },
  // 品牌好物列表（統一 status 篩選：訂單態/禮物態），資料存於 state.brandGifts
  // /brandGifts 回傳 { code, message, data: { 分頁物件 } }，需取 data.data 為分頁物件
  // shipsnFrom / shipsnTo：寄件單建立時間區間（訂單態篩選用）
  getBrandGifts ({commit, state}, {status, page, perPage = 15, keyword = '', shipsnFrom = '', shipsnTo = '', cb}) {
    userApi.getBrandGifts(status, page, perPage, keyword, shipsnFrom, shipsnTo, (data) => {
      console.log('>>>>> result data >>>>>>', data)
      if (data && !data.error) {
        commit('setBrandGifts', {status, data: data.data})
      }
      return cb(data)
    })
  },
  // 某品牌好物的索取列表指定頁；已抓過的頁直接命中快取，不重複請求
  // 第 1 頁由 setBrandGifts 從列表的 nested orders 預覽 seed，故永遠不需請求
  getBrandGiftOrders ({commit, state}, {giftId, page, status = '', shipsnFrom = '', shipsnTo = '', cb}) {
    const entry = state.brandGiftOrders[giftId]
    if (entry && entry.pages[page]) {
      commit('setBrandGiftOrdersCurrentPage', {giftId, page})
      // 無回應物件：呼叫端只需判斷有無 error，命中快取等同成功
      return cb && cb()
    }
    commit('setBrandGiftOrdersLoading', {giftId, loading: true})
    userApi.getBrandGiftOrders(giftId, page, ORDER_PER_PAGE, status, shipsnFrom, shipsnTo, (data) => {
      commit('setBrandGiftOrdersLoading', {giftId, loading: false})
      if (data && !data.error) {
        commit('setBrandGiftOrdersPage', {giftId, page, data: data.data})
      }
      return cb && cb(data)
    })
  },
  getUserOtherGifts ({commit, state}, {page, userId, status, cb}) {
    userApi.getUserGifts(page, userId, status, (data) => {
      if (data && !data.error) {
        commit('setMyOtherGifts', {userId, data})
      }
      return cb(data)
    })
  },
  getUserNeedDonates ({commit, state}, {page, userId, cb}) {
    userApi.getUserNeedDonates(page, userId, (data) => {
      if (data && !data.error) {
        commit('setMyNeedDonates', {userId, data})
      }
      return cb(data)
    })
  },
  getUserNeeds ({commit, state}, {page, userId, cb}) {
    userApi.getUserNeeds(page, userId, (data) => {
      if (data && !data.error) {
        commit('setMyNeeds', {userId, data})
      }
      return cb(data)
    })
  },
  getUserRequests ({commit, state}, {page, userId, status, index, cb, keyword = ''}) {
    userApi.getUserRequests(page, userId, status, (data) => {
      if (data && !data.error) {
        commit('setMyRequests', {userId, data, index})
      }
      return cb(data)
    }, keyword)
  },
  getUserRequestLoveBoxes ({commit, state}, { page, userId, index }) {
    return loveboxApi.getUserRequestLoveBoxes(userId, page, 10)
      .then(data => {
        commit('setMyRequests', { userId, data, index })
        return data
      }).catch(err => {
        console.log(err)
      })
  },
  changeUserPassword ({commit, state}, {oldpw, newpw, cb}) {
    userApi.changePassword(oldpw, newpw, (data) => {
      return cb(data)
    })
  },
  resetUserPassword ({commit, state}, {email, cb}) {
    userApi.resetpassword(email, (data) => {
      cb(data)
      // return commit('changeResetPwStep', )
    })
  },
  resetUserCellPhonePassword ({commit, state}, {cellphone, password, repeatPassword, token, cb}) {
    userApi.resetcellphonepassword(cellphone, password, repeatPassword, token, (data) => {
      cb(data)
    })
  },
  getTraceThing ({commit, state}, {userId, type, page, perPage = 15, cb = null} = {}) {
    commit('setTraceThingLoading', {userId, type, loading: true})
    userApi.getTraceThing(type, page, perPage, (data) => {
      if (data && !data.error) {
        commit(`setTraceThing`, {userId, type, data})
      }
      if (cb) {
        cb(data)
      }
    })
  },
  unTraceThing ({commit, state}, {userId, id, type}) {
    userApi.unTraceThing(id, type, (data) => {
      commit(`setUnTraceThing`, {userId, type, id})
    })
  },
  modify ({commit, state}, {dataObj, cb}) {
    userApi.modify(dataObj, (data) => {
      cb(data)
      if (!data.error) {
        commit('setLoginUserInfo', {
          ...dataObj,
          ...data
        })
      }
    })
  },
  confirmVerifyLoveBox ({commit, state}, {code, cb}) {
    userApi.confirmVerifyLoveBox(code, (data) => {
      if (data && !data.error) {
        commit('updateVerifyLoveBox')
      }
      cb(data)
    })
  },
  sendCodeVerifyCellPhone ({commit, state}, {cellphone, cb}) {
    userApi.sendCodeVerifyCellPhone(cellphone, (data) => {
      cb(data)
    })
  },
  async confirmVerifyCellPhone ({commit, state}, {cellphone, token, cb}) {
    const data = await userApi.confirmVerifyCellPhone(cellphone, token)
    if (data && !data.error) {
      commit('updateVerifyCellphone', {data})
    }
    cb(data)
  },
  sendVerifyEmail ({commit, state}, {email, cb}) {
    userApi.sendVerifyEmail(email, (data) => {
      cb(data)
    })
  },
  confirmVerifyEmail ({commit, state}, {usrHash, token, cb}) {
    userApi.confirmVerifyEmail(usrHash, token, (data) => {
      if (data && !data.error) {
        commit('updateVerifyEmail')
      }
      cb(data)
    })
  },
  confirmVerifyName ({commit, state}, {idImage, docImage, cb}) {
    userApi.confirmVerifyName(idImage, docImage, (data) => {
      cb(data)
    })
  },
  verifyNickname ({commit}, nickname) {
    return userApi.isNicknameBeTaken(nickname)
      .then(result => {
        return result.data.exists
      })
  },
  changeUserRoles ({commit, state}, {dataObj, cb}) {
    userApi.changeUserRoles(dataObj, (data) => {
      cb(data)
    })
  },
  getUserMarks ({commit, state}, {type, page, perPage = 15, cb = null} = {}) {
    commit('setUserMarksLoading', {type, loading: true})
    userApi.getUserMarks(
      type,
      page,
      perPage,
      (data) => {
        if (data && !data.error) {
          commit('setUserMarks', {type, data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  cancelMark ({commit, state}, {userId, type, cb = null} = {}) {
    userApi.cancelMark(
      userId,
      (data) => {
        if (cb) {
          cb(data)
        }

        if (data && !data.error) {
          commit('cancelMark', { userId, type })
        }
      }
    )
  },
  makeMarks ({commit, state}, {content, userId, type, cb = null} = {}) {
    userApi.makeMarks(
      content,
      userId,
      type,
      (data) => {
        if (cb) {
          cb(data)
        }
        if (data && !data.error) {
          commit('markUser', { userId, type, content, data })
        }
      }
    )
  },
  traceUser ({commit, state}, {isTrace, userId, cb = null} = {}) {
    userApi.traceUser(
      isTrace,
      userId,
      (data) => {
        commit('setTraceUser', {isTrace})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  updateConnect ({commit, state}, {data, cb}) {
    userApi.updateConnect(
      data,
      (data) => cb(data)
    )
  },
  getUserSentLovebox ({commit, state}, {userId, status, page, perPage}) {
    return loveboxApi.getUserLovebox(userId, status, page, perPage)
      .then(data => {
        commit('setUserSentLovebox', {data})
        return data
      }).catch(err => {
        console.log(err)
      })
  },
  getUserRegisterCode ({ commit }) {
    return userApi.getUserRegisterCode()
      .then(data => {
        commit('setUserRegisterCode', { data: data.data })
        return data
      }).catch(err => {
        console.log(err)
      })
  },
  changeMomentBanner ({ commit }, momentBannerImage) {
    return momentApi.changeMomentBanner(momentBannerImage)
      .then(data => {
        commit('setUserMomentBanner', momentBannerImage)
        return data
      })
  },
  logout ({ commit }) {
    return enterApi.logout()
      .then(() => {
        commit('logout')
        commit('resetDeals')
        commit('resetMessageList')
      })
      .catch(() => {
        commit('logout')
        commit('resetDeals')
        commit('resetMessageList')
      })
  },
  getMyAddresses ({ commit, state }) {
    if (state.addresses.length) {
      return new Promise((resolve) => {
        resolve(state.addresses)
      })
    }
    return userApi.getMyAddresses()
      .then(res => {
        if (!res || !res.data) {
          return []
        }
        commit('setMyAddresses', res.data)
        return res.data
      })
  },
  addAddress ({ commit }, data) {
    return userApi.addAddress(data)
      .then(res => {
        commit('addAddress', res.data)
        return res.data
      })
  },
  removeAddress ({ commit }, addressId) {
    return userApi.removeAddress(addressId)
      .then(res => {
        commit('removeAddress', addressId)
        return res.data
      })
  },
  updateAddress ({ commit }, { addressId, data }) {
    return userApi.updateAddress(addressId, data)
      .then(res => {
        commit('updateAddress', res.data)
        return res.data
      })
  },
  getHaveSucceedPalmbox ({ commit }) {
    return userApi.getMyHaveSucceedPalmboxOrder()
      .then(res => {
        commit('setHaveSucceedPalmbox', res.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getAccountRisk ({ commit }) {
    return userApi.getAccountRisk()
      .then((res) => {
        commit('setAccountRisk', res.data)
        return res
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getMyWalletPoints ({ commit }) {
    return userApi.getMyWalletPoints()
      .then((res) => {
        commit('setMyWalletPoints', res.data)
        return res.data
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getMyWalletChargeOrders ({ commit }, { page, perPage }) {
    commit('setMyWalletChargeOrdersLoading', true)
    return userApi.getMyWalletChargeOrders(page, perPage)
      .then((res) => {
        commit('setMyWalletChargeOrders', res.data)
        return res.data
      })
  },
  getMyWalletRecords ({ commit }, { page, perPage }) {
    commit('setMyWalletRecordsLoading', true)
    return userApi.getMyWalletRecords(page, perPage)
      .then((res) => {
        commit('setMyWalletRecords', res.data)
        return res.data
      })
  },
  getWalletChargeCount ({ commit }) {
    return userApi.getWalletChargeCount()
      .then((res) => {
        commit('setWalletChargetCount', res.data)
        return res.data
      })
  },
  getMyUnpaidDeals ({ commit }) {
    commit('setMyUnpaidDealsLoading', true)
    return dealApi.getMyUnpaidDeals()
      .then((res) => {
        commit('setMyUnpaidDeals', res.data)
        return res.data
      })
  },
  getMySponsorRecords ({ commit }, { page, perPage }) {
    commit('setMySponsorRecordsLoading', true)
    return userApi.getMySponsorRecords(page, perPage)
      .then((res) => {
        commit('setMySponsorRecords', res.data)
        return res.data
      })
  },
  getMyCouponRecords ({ commit }, { status, page, perPage }) {
    commit('setCouponRecordsLoading', { status, loading: true })
    return userApi.getMyCouponRecords(status, page, perPage)
      .then((res) => {
        commit('setCouponRecords', { status, data: res.data })
      })
      .catch((err) => {
        commit('setCouponRecordsLoading', { status, loading: false })
        throw err
      })
  },
  getUserProfileGifts ({commit, state}, {page, userId, status, type, noRequestList}) {
    userApi.getUserGifts(page, userId, status, type, noRequestList, (data) => {
      if (data && !data.error) {
        commit('setMyGifts', {userId, status, data})
        commit('setUserProfileGifts', { userId, status, data })
      }
      return data
    })
  },
  getUserProfileNeeds ({commit, state}, {page, userId, status}) {
    userApi.getUserNeeds(page, userId, (data) => {
      if (data && !data.error) {
        commit('setUserProfileNeeds', {userId, data})
      }
      return data
    }, 10, status)
  },
  getCompanyProfile ({ commit, state }, { userId }) {
    commit('setCompanyProfileLoading', { userId, loading: false })
    return userApi.getCompanyProfile(userId)
      .then((data) => {
        commit('setCompanyProfile', { userId, data })
        return data
      })
  },
  getUserMedalList ({ commit }, { page, festivalId, userId }) {
    return userApi.getFestivalMedalList(page, festivalId, userId)
      .then((res) => {
        commit('setUserMedalList', { userId, data: res.data })
        return res.data
      })
  },
  getMyMedalList ({ commit }, { page, festivalId }) {
    return userApi.getFestivalMedalList(page, festivalId)
      .then((res) => {
        commit('setMyMedalList', { data: res.data })
        return res.data
      })
  },
  getThankTemplates ({ commit }, { page, perPage }) {
    return userApi.getThankTemplates(page, perPage)
      .then((res) => {
        commit('setThankTemplates', { data: res.data })
        return res.data
      })
  },
  addThankTemplate ({ commit }, data) {
    return userApi.addThankTemplate(data)
      .then(res => {
        commit('addThankTemplate', res.data)
        return res.data
      })
  },
  removeThankTemplate ({ commit }, thankId) {
    return userApi.removeThankTemplate(thankId)
      .then(res => {
        commit('removeThankTemplate', thankId)
        return res.data
      })
  },
  updateThankTemplate ({ commit }, { thankId, data }) {
    return userApi.updateThankTemplate(thankId, data)
      .then(res => {
        commit('updateThankTemplate', res.data)
        return res.data
      })
  },
  removeCarbonLabellingGroup ({ commit }, { groupId }) {
    commit('removeCarbonLabellingGroup', { groupId })
  }
}

const mutations = {
  setToken (state, {token}) {
    state.token = token
  },
  logout (state) {
    state.token = ''
    state.userInfo.id = ''
    state.userInfo.token = ''
    state.userInfo.frozen = false
    state.myRegisterCode = ''
    state.userInfo.traceUsers = {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    }
    state.userInfo.traceGifts = {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    }
    state.userInfo.traceNeeds = {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    }
    state.userInfo.traceProvisions = {
      currentPage: 0,
      nextPageUrl: '//',
      data: []
    }
    state.userInfo.myGiftsTabIndex = 0
    state.userInfo.myGiftsStatusIndex = 0
    state.userInfo.myGifts = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: [],
      status: ''
    }
    state.userInfo.myNeedDonates = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state.userInfo.myNeeds = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state.userInfo.myRequestsTabIndex = 0
    state.userInfo.myRequestKeyword = ''
    state.userInfo.myRequests = [{
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []}, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []}, {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }]
    state.userInfo.companyProfile = {
      loading: false
    }
    state.userInfo.medalList = {
      loading: false,
      data: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
    state.otherUserInfo = {
      token: '',
      myGiftsTabIndex: 0,
      myGiftsStatusIndex: 0,
      myGifts: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: [],
        status: ''
      },
      myNeedDonates: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      },
      myNeeds: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      },
      myRequestsTabIndex: 0,
      myRequests: [{
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }, {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }, {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }],
      traceUsers: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      traceGifts: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      traceNeeds: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      traceIdx: 0,
      companyProfile: {
        loading: false
      },
      medalList: {
        loading: false,
        data: [],
        currentPage: 0,
        lastPage: 1,
        total: 0
      }
    }
    state.marks = {
      WHITE: {
        curPage: 0,
        data: [],
        total: 0,
        lastPage: 1,
        loading: false
      },
      NORMAL: {
        curPage: 0,
        data: [],
        total: 0,
        lastPage: 1,
        loading: false
      },
      BLACK: {
        curPage: 0,
        data: [],
        total: 0,
        lastPage: 1,
        loading: false
      },
      curIdx: 0
    }
    state.wallet = {
      points: 0,
      hasPasscode: 1,
      chargeCount: -1,
      chargeOrders: {
        items: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      records: {
        items: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      unpaidDeals: {
        giftRequests: [],
        needDonates: [],
        loveOrders: [],
        total: 0,
        loading: false
      },
      couponRecords: [
        {
          status: COUPON_RECORD_STATUS.VALID,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        },
        {
          status: COUPON_RECORD_STATUS.USED,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        },
        {
          status: COUPON_RECORD_STATUS.EXPIRED,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        }
      ]
    }
    state.sponsorRecrods = {
      loading: false,
      items: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
    state.addresses = []
    state.brandGifts = {
      status: '',
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state.brandGiftOrders = {}
    state.brandGiftStatusCounts = {}
    localStorage.removeItem(KEY_USER_TOKEN)
  },
  resetOtherUserInfo (state) {
    state.otherUserInfo = {
      myGiftsTabIndex: 0,
      myGiftsStatusIndex: 0,
      profileGifts: {
        currentPage: 0,
        nextPageUrl: 'http://',
        status: '',
        data: []
      },
      profileNeeds: {
        currentPage: 0,
        nextPageUrl: 'http://',
        status: '',
        data: []
      },
      myGifts: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: [],
        status: ''
      },
      myNeedDonates: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      },
      myNeeds: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      },
      myRequestsTabIndex: 0,
      myRequests: [{
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }, {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }, {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }, {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }],
      traceUsers: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      traceGifts: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      traceNeeds: {
        currentPage: 0,
        nextPageUrl: '//',
        data: []
      },
      sentLovebox: {
        currentPage: 0,
        total: 0,
        data: []
      },
      companyProfile: {
        loading: false
      },
      medalList: {
        loading: false,
        data: [],
        currentPage: 0,
        lastPage: 1,
        total: 0
      }
    }
  },
  login (state, {token}) {
    state.userInfo.token = token
    state.token = token
  },
  setLoginUserInfo (state, {data}) {
    if (!data) {
      console.log('已登錄用戶數據為空')
      return
    }

    const others = JSON.parse(data.others)
    const verifyInfo = data.verify_info && JSON.parse(data.verify_info)
    const {veri_cell: veriCell, veri_mail: veriMail, veri_ppl: veriPpl} = data
    let verify = {
      mail: typeof veriMail === 'boolean' ? veriMail : (veriMail === 'Y'),
      cell: typeof veriCell === 'boolean' ? veriCell : (veriCell === 'Y'),
      ppl: typeof veriPpl === 'boolean' ? veriPpl : (veriPpl === 'Y')
    }
    verify.vip = verify.mail && verify.cell

    state.userInfo = {
      ...state.userInfo,
      ...Object.assign({}, Object.keys(data).map(key => {
        return {
          [key.replace(/_(\w{1})/g, (a, b) => (b.toUpperCase()))]: data[key]
        }
      }).reduce((pre, next) => ({...pre, ...next})), {others, verifyInfo}),
      // 部分老用戶的nickname或infos均為字符串 'NULL' 因此也要替換
      nickname: data.nickname && memberData.isNull(data.nickname) ? data.nickname : '暫無暱稱',
      infos: data.infos && memberData.isNull(data.infos) ? data.infos : '',
      verify
    }

    Vue.analytics.setUserId(data.id)
  },
  setOtherUserInfo (state, {data}) {
    if (!data) {
      console.log('mutation', data)
      console.log('查无此人')
      return
    }
    const others = data.others ? JSON.parse(data.others) : {}
    state.otherUserInfo = {
      ...state.otherUserInfo,
      ...Object.assign({}, Object.keys(data).map(key => {
        return {
          [key.replace(/_(\w{1})/g, (a, b) => (b.toUpperCase()))]: data[key]
        }
      }).reduce((pre, next) => ({...pre, ...next})), {others}),
      nickname: data.nickname && memberData.isNull(data.nickname) ? data.nickname : '暫無暱稱',
      infos: data.infos && memberData.isNull(data.infos) ? data.infos : ''
    }
  },
  resetLoginUserInfo () {
    state.userInfo = {
      id: 0,
      pics: '',
      catHash: 'normal',
      catId: 36,
      nickname: '',
      name: '',
      email: '',
      cellphone: '',
      phone: '',
      income: '', // 年收入
      infos: '', // 自我介绍
      createTime: '',
      lastLoginTime: '',
      isGOV: false,
      isComMger: false,
      isCompany: false,
      frozen: false,
      verify: {
        cell: false,
        ppl: false, // 实名
        email: false,
        love: false // 爱箱送
      },
      others: {
        addresses: {
          meets: {
            address: '',
            city: '',
            district: ''
          },
          rcvs: {
            address: '',
            city: '',
            district: ''
          },
          things: {
            address: '',
            city: '',
            district: ''
          },
          users: {
            address: '',
            city: '',
            district: ''
          }
        },
        banks: [{
          accounts: '',
          banks: '',
          branchs: '',
          title: ''
        }, {
          accounts: '',
          banks: '',
          branchs: '',
          title: ''
        }],
        birthday: {
          value: '',
          isPub: false
        },
        jobs: {
          value: '', // 枚举值 有工作 无工作 学生
          isPub: false
        },
        childs: {
          value: false, // 是否育儿
          isPub: false
        },
        marry: {
          value: false,
          isPub: false
        },
        gender: null,
        isIPOCompany: false,
        issues: [], // 关心议题
        fami: '' // 预设全家收件
      },
      verifyInfo: {
        position: '',
        fullname: '',
        cat_hash: '',
        taxnum: '',
        no: '',
        type: '',
        purpose: '',
        advise_no: '',
        contact_tel: '',
        contact_phone: '',
        contact_name: ''
      },
      bonus: 0, // 好人点
      reviews_rate: 0, // 感谢率
      charitys: 0, // 公益捐赠
      fans: 0, // 粉丝人数
      traces: 0, // 追踪人数
      invite_code: '', // 爱箱送邀请码
      token: ''
    }
    state.wallet = {
      points: 0,
      hasPasscode: 1,
      chargeCount: -1,
      chargeOrders: {
        items: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      records: {
        items: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0
      },
      unpaidDeals: {
        giftRequests: [],
        needDonates: [],
        loveOrders: [],
        total: 0,
        loading: false
      },
      couponRecords: [
        {
          status: COUPON_RECORD_STATUS.VALID,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        },
        {
          status: COUPON_RECORD_STATUS.USED,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        },
        {
          status: COUPON_RECORD_STATUS.EXPIRED,
          data: [],
          loading: false,
          currentPage: 0,
          lastPage: 1,
          total: 0
        }
      ]
    }
    state.sponsorRecrods = {
      loading: false,
      items: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
  },
  setMyGifts (state, {userId, status, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myGifts = {
      ...state[user].myGifts,
      status,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].myGifts.data,
        ...data.data
      ]
    }
  },
  setBrandGifts (state, {status, data}) {
    state.brandGifts = {
      ...state.brandGifts,
      status,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state.brandGifts.data,
        ...data.data
      ]
    }
    // 列表回傳的 nested orders 就是索取列表第 1 頁（含 total/last_page），直接 seed 進快取
    // 第 1 頁 === 1 時整份重建（切 tab／刷新／改篩選）；否則只補新禮物，
    // 不動既有禮物的 currentPage（外層無限滾動不該把已翻頁的卡片打回第 1 頁）
    const seeded = data.current_page === 1 ? {} : {...state.brandGiftOrders}
    data.data.forEach((gift) => {
      const orders = gift.orders
      if (!orders || seeded[gift.id]) {
        return
      }
      seeded[gift.id] = {
        pages: {1: orders.data || []},
        currentPage: 1,
        total: orders.total || 0,
        lastPage: orders.last_page || 1,
        perPage: orders.per_page || ORDER_PER_PAGE,
        loading: false
      }
    })
    state.brandGiftOrders = seeded
    // tab 統計數字與分頁欄位平級；每次請求（含翻頁）都會回，有就更新
    if (data.status_counts) {
      state.brandGiftStatusCounts = data.status_counts
    }
  },
  // 寫入某禮物索取列表的指定頁（data 為後端分頁物件）
  setBrandGiftOrdersPage (state, {giftId, page, data}) {
    const entry = state.brandGiftOrders[giftId]
    if (!entry) {
      return
    }
    Vue.set(entry.pages, page, data.data || [])
    // total/lastPage 以最新回應為準（期間可能有新索取進來）
    Vue.set(state.brandGiftOrders, giftId, {
      ...entry,
      currentPage: page,
      total: data.total != null ? data.total : entry.total,
      lastPage: data.last_page || entry.lastPage
    })
  },
  // 快取命中時只切頁碼，不發請求
  setBrandGiftOrdersCurrentPage (state, {giftId, page}) {
    const entry = state.brandGiftOrders[giftId]
    if (!entry) {
      return
    }
    Vue.set(state.brandGiftOrders, giftId, {...entry, currentPage: page})
  },
  setBrandGiftOrdersLoading (state, {giftId, loading}) {
    const entry = state.brandGiftOrders[giftId]
    if (!entry) {
      return
    }
    Vue.set(state.brandGiftOrders, giftId, {...entry, loading})
  },
  resetBrandGifts (state) {
    state.brandGifts = {
      status: '',
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state.brandGiftOrders = {}
    // 刻意不清 brandGiftStatusCounts：切 tab／刷新時數字口徑不變，
    // 清掉會讓 tab 上的括號數字在載入期間整排消失又跳回來
  },
  setMyOtherGifts (state, {userId, data}) {
    state.otherUserInfo.myOthGifts = {
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...data.data
      ]
    }
  },
  setMyGiftsTabIndex (state, {userId, index}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myGiftsTabIndex = index
  },
  setMyGiftsTabStatusIndex (state, {userId, index}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myGiftsStatusIndex = index
  },
  setMyNeedDonates (state, {userId, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myNeedDonates = {
      ...state[user].myNeedDonates,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].myNeedDonates.data,
        ...data.data
      ]
    }
  },
  setMyNeeds (state, {userId, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myNeeds = {
      ...state[user].myNeeds,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].myNeeds.data,
        ...data.data
      ]
    }
  },
  setMyRequests (state, {userId, data, index}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myRequests[index] = {
      ...state[user].myRequests[index],
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state[user].myRequests[index].data,
        ...data.data
      ]
    }
    state[user].myRequests = [...state[user].myRequests]
  },
  clearMyRequests (state, {userId, index}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myRequests[index] = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state[user].myRequests = [...state[user].myRequests]
  },
  setMyRequestsTabIndex (state, {userId, index}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myRequestsTabIndex = index
  },
  setMyRequestKeyword (state, {userId, keyword}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].myRequestKeyword = keyword
  },
  setTraceThingLoading (state, {userId, type, loading}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    let userInfo = Object.assign({}, state[user])
    const key = `trace${type.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())}s`
    userInfo[key] = {
      ...userInfo[key],
      loading
    }
    state[user] = userInfo
  },
  setTraceThing (state, {userId, type, data}) {
    // “我”追蹤的用戶，不能查看其它用戶的追蹤
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    let userInfo = Object.assign({}, state[user])
    const key = `trace${type.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())}s`
    userInfo[key] = {
      ...userInfo[key],
      data: data.current_page === 1 ? data.data : [...userInfo[key].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page,
      loading: false
    }
    state[user] = userInfo
  },
  setUnTraceThing (state, {userId, type, id}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    const tmp = `trace${type.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())}s`
    const key = {
      user: 'trace_user_id',
      gift: 'gift_id',
      need: 'need_id',
      provision: 'love_provision_id'
    }[type]
    state[user][tmp].data = state.userInfo[tmp].data.filter(item => item[key] !== id)
  },
  setMyAvatar (state, {data}) {
    state.userInfo.avatar = [
      ...state.userInfo.avatar,
      data
    ]
  },
  deleteMyAvatar (state, {i}) {
    state.userInfo.avatar = state.userInfo.avatar.filter((item, index) => i !== index)
  },
  updateVerifyCellphone (state, {data}) {
    if (data.error) {
      return 'error'
    }
    state.userInfo.veriCell = 'Y'
  },
  updateVerifyEmail (state) {
    state.userInfo.veriMail = 'Y'
  },
  updateVerifyLoveBox (state) {
    state.userInfo.love = 1
  },
  setTraceUser (state, {isTrace}) {
    state.otherUserInfo = {
      ...state.otherUserInfo,
      isTracing: !isTrace
    }
  },
  setTraceIdx (state, {idx}) {
    state.userInfo.traceIdx = idx
  },
  setUserMarksLoading (state, {type, loading}) {
    state.marks = {
      ...state.marks,
      [type]: {
        ...state.marks[type],
        loading: true
      }
    }
  },
  setUserMarks (state, {type, data}) {
    state.marks = {
      ...state.marks,
      [type]: {
        curPage: data.current_page,
        total: data.total,
        lastPage: data.last_page,
        loading: false,
        data: data.current_page === 1 ? data.data : [...state.marks[type].data, ...data.data]
      }
    }
  },
  setMarksCurIdx (state, idx) {
    state.marks.curIdx = idx
  },
  setUserSentLovebox (state, {data}) {
    state.otherUserInfo.sentLovebox = {
      ...state.otherUserInfo.sentLovebox,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      total: data.total,
      data: data.current_page === 1 ? data.data : [
        ...state.otherUserInfo.sentLovebox.data,
        ...data.data
      ]
    }
  },
  setUserRegisterCode (state, { data }) {
    state.myRegisterCode = data.register_code
  },
  markUser (state, { userId, type, content, data }) {
    if (userId === state.otherUserInfo.id) {
      state.otherUserInfo.markType = type
      state.otherUserInfo.markContent = content
    }

    if (state.marks[type].curPage !== 0) {
      let find = false
      for (let i = 0; i < state.marks[type].data.length; ++i) {
        if (state.marks[type].data[i].mark_user_id === userId) {
          find = true
          state.marks[type].data[i] = {
            ...state.marks[type].data[i],
            content
          }
          break
        }
      }

      if (!find) {
        state.marks[type].data = [
          ...state.marks[type].data,
          {
            ...data
          }
        ]
        state.marks[type].total += 1
      }
    }
  },
  cancelMark (state, { userId, type }) {
    for (let i = 0; i < state.marks[type].data.length; ++i) {
      if (state.marks[type].data[i].mark_user_id === userId) {
        state.marks[type].data.splice(i, 1)
        state.marks[type].total -= 1
        break
      }
    }
  },
  setUserMomentBanner (state, momentBannerImage) {
    state.userInfo = {
      ...state.userInfo,
      momentBannerImage: momentBannerImage
    }
  },
  setMyAddresses (state, data) {
    state.addresses = data
  },
  addAddress (state, data) {
    if (data.default) {
      state.addresses.map(item => {
        item.default = false
        return item
      })
    }
    state.addresses.unshift(data)
  },
  removeAddress (state, addressId) {
    state.addresses = state.addresses.filter(item => item.id !== addressId)
  },
  updateAddress (state, data) {
    for (let i = 0; i < state.addresses.length; ++i) {
      if (state.addresses[i].id === data.id) {
        state.addresses[i] = {
          ...state.addresses[i],
          ...data
        }

        if (data.default) {
          state.addresses.map(item => {
            if (data.id !== item.id) {
              item.default = false
            }
            return item
          })
        }
        state.addresses = [...state.addresses]
      }
    }
  },
  setCurrentSelectedAddressId (state, addressId) {
    state.currentSelectedAddressId = addressId
  },
  setHaveSucceedPalmbox (state, data) {
    state.haveSucceedPalmbox = data
  },
  setAccountRisk (state, data) {
    state.isAccountRisk = data
  },
  setMyWalletPoints (state, data) {
    state.wallet.points = data.remain
    state.wallet.hasPasscode = data.has_pass_code
  },
  setMyWalletChargeOrdersLoading (state, loading) {
    state.wallet.chargeOrders = {
      ...state.wallet.chargeOrders,
      loading
    }
  },
  setMyWalletChargeOrders (state, data) {
    state.wallet.chargeOrders = {
      items: data.current_page === 1 ? data.items : state.wallet.chargeOrders.items.concat(data.items),
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }
  },
  setMyWalletRecordsLoading (state, loading) {
    state.wallet.records = {
      ...state.wallet.records,
      loading
    }
  },
  setMyWalletRecords (state, data) {
    state.wallet.records = {
      items: data.current_page === 1 ? data.items : state.wallet.records.items.concat(data.items),
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }
  },
  setHasWalletPasscode (state, data) {
    state.wallet.hasPasscode = data
  },
  setWalletChargeOrderInvoice (state, data) {
    for (let order of state.wallet.chargeOrders.items) {
      if (order.id === data.orderId) {
        order.tax_no = data.taxNo
      }
    }
  },
  setWalletChargetCount (state, count) {
    state.wallet.chargeCount = count
  },
  setMyUnpaidDealsLoading (state, loading) {
    state.wallet.unpaidDeals = {
      ...state.wallet.unpaidDeals,
      loading
    }
  },
  setMyUnpaidDeals (state, data) {
    state.wallet.unpaidDeals = {
      giftRequests: data.gift_requests,
      needDonates: data.need_donates,
      loveOrders: data.love_orders,
      loading: false,
      total: data.gift_requests.length + data.need_donates.length + data.love_orders.length
    }
  },
  setMySponsorRecordsLoading (state, loading) {
    state.sponsorRecrods = {
      ...state.sponsorRecrods,
      loading
    }
  },
  setMySponsorRecords (state, data) {
    state.sponsorRecrods = {
      items: data.current_page === 1 ? data.items : state.sponsorRecrods.items.concat(data.items),
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }
  },
  setUserAvatar (state, avatar) {
    state.userInfo = {
      ...state.userInfo,
      pics: avatar
    }
  },
  addNewGift (state, data) {
    if (state.userInfo.myGifts.data.length) {
      state.userInfo.myGifts.data.unshift(data)
    }
  },
  setCouponRecords (state, { status, data }) {
    for (let couponRecord of state.wallet.couponRecords) {
      if (couponRecord.status === status) {
        couponRecord.currentPage = data.current_page
        couponRecord.data = data.current_page === 1 ? data.data : [...couponRecord.data, ...data.data]
        couponRecord.loading = false
        couponRecord.total = data.total
        couponRecord.lastPage = data.last_page
      }
    }
  },
  setCouponRecordsLoading (state, { status, loading }) {
    for (let couponRecord of state.wallet.couponRecords) {
      if (couponRecord.status === status) {
        couponRecord.loading = loading
      }
    }
  },
  setUserProfileGifts (state, {userId, status, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].profileGifts = {
      ...state[user].profileGifts,
      status,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].profileGifts.data,
        ...data.data
      ]
    }
  },
  setUserProfileNeeds (state, {userId, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].profileNeeds = {
      ...state[user].profileNeeds,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].profileNeeds.data,
        ...data.data
      ]
    }
  },
  setCompanyProfileLoading (state, { userId, loading }) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].companyProfile.loading = loading
  },
  setCompanyProfile (state, { userId, data }) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    const area = data.areas
    area.data = area.data.map(item => {
      item.name = item.name.replace('台', '臺')
      item.percent /= 100
      return item
    })
    area.data.sort((a, b) => b.value - a.value)
    state[user].companyProfile = {
      loading: false,
      ...data
    }
  },
  updateMyProfile (state, { count }) {
    state.userInfo.welfareMedal += count
  },
  setUserMedalList (state, {userId, data}) {
    const user = Number(userId) === Number(state.userInfo.id) ? 'userInfo' : 'otherUserInfo'
    state[user].medalList = {
      ...state[user].medalList,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state[user].medalList.data,
        ...data.data
      ]
    }
  },
  setMyMedalList (state, { data }) {
    state.userInfo.medalList = {
      ...state.userInfo.medalList,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: data.current_page === 1 ? data.data : [
        ...state.userInfo.medalList.data,
        ...data.data
      ]
    }
  },
  setThankTemplates (state, { data }) {
    state.thankTemplates = {
      data: data.current_page === 1 ? data.data : state.thankTemplates.data.concat(data.data),
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }
  },
  addThankTemplate (state, data) {
    state.thankTemplates.data.unshift(data)
  },
  removeThankTemplate (state, thankId) {
    state.thankTemplates.data = state.thankTemplates.data.filter(item => item.id !== thankId)
  },
  updateThankTemplate (state, data) {
    for (let i = 0; i < state.thankTemplates.data.length; ++i) {
      if (state.thankTemplates.data[i].id === data.id) {
        state.thankTemplates.data[i] = {
          ...state.thankTemplates.data[i],
          ...data
        }
        state.thankTemplates.data = [...state.thankTemplates.data]
      }
    }
  },
  setCurrentSelectedThankId (state, thankId) {
    state.currentSelectedThankId = thankId
  },
  removeCarbonLabellingGroup (state, { groupId }) {
    if (state.userInfo.carbonLabellings) {
      state.userInfo.carbonLabellings = state.userInfo.carbonLabellings.filter(item => item.id !== groupId)
    }
  }
}

const getters = {
  currentSelectedAddress (state) {
    if (!state.addresses.length) {
      return null
    }

    if (state.currentSelectedAddressId) {
      return state.addresses.find(item => item.id === state.currentSelectedAddressId)
    }

    return state.addresses.find(item => item.default) || state.addresses[0]
  },
  currentMeetAddress (state) {
    if (!state.addresses.length) {
      return null
    }

    if (state.currentSelectedAddressId) {
      return state.addresses.find(item => item.id === state.currentSelectedAddressId)
    }

    return state.addresses.find(item => item.remark === '面交') ||
      state.addresses.find(item => item.default) ||
      state.addresses[0]
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
